import React, { useEffect, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useConfig } from "../../../../../../app/configcontext";
import ProtectedPaymentRoute from "../../../../../auth/Auth";

export default function NameConfirm() {
  ProtectedPaymentRoute();

  const config = useConfig();
  const state = useSelector((state) => state.business);
  const businessDetails = state?.businessDetails || {};
  const businessTypeId = state?.businessTypeId;
  const designatorList = useMemo(() => config?.designator || [], [config?.designator]);
  const navigate = useNavigate();

  const savedDesignator = useMemo(() => {
    if (!businessDetails?.designatorId) return "";
    const designator = designatorList.find(
      (item) => item.id === businessDetails.designatorId
    );
    return designator?.name || "";
  }, [businessDetails?.designatorId, designatorList]);

  const savedBusinessName = businessDetails?.businessName || "your business";
  const savedState = state?.businessLocation?.state || "--";
  const entryType = businessTypeId === 2 ? "Corporation" : savedDesignator || "Limited Liability Company";

  const handleNextButtonClick = useCallback(() => {
    navigate(businessTypeId === 1 ? "/contact_details" : "/corpo_help");
  }, [navigate, businessTypeId]);

  useEffect(() => {
    const handleNextPress = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        handleNextButtonClick();
      }
    };
    document.addEventListener("keydown", handleNextPress);
    return () => {
      document.removeEventListener("keydown", handleNextPress);
    };
  }, [handleNextButtonClick]);

  const backbtn = () => {
    navigate("/business_location");
  };

  return (
    <div className="min-h-[80vh] bg-[#f8f9fa] py-12 lg:py-16 font-sans flex items-center justify-center">
      <div className="container mx-auto px-4 lg:px-8 max-w-2xl">
        <div className="bg-white rounded-[16px] border border-[#dadce0] p-8 sm:p-12 shadow-sm text-center">
          
          {/* Header Icon */}
          <div className="w-16 h-16 rounded-full bg-[#e6f4ea] flex items-center justify-center text-[#1e8e3e] mx-auto mb-6 shadow-sm">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>

          <span className="text-[#1a73e8] font-medium tracking-wider uppercase text-xs mb-2 block">
            Step 3 of Business Formation
          </span>
          <h1 className="text-2xl sm:text-3xl font-medium text-[#202124] tracking-tight mb-4">
            Great, let's get <span className="text-[#1a73e8] font-semibold">{savedBusinessName}</span> set up!
          </h1>
          <p className="text-[14.5px] text-[#5f6368] mb-8 max-w-lg mx-auto">
            We will conduct a comprehensive official name availability search during your state registration filing.
          </p>

          {/* Entity Summary Card */}
          <div className="bg-[#f8f9fa] rounded-[12px] p-6 border border-[#dadce0] mb-8 text-left">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div>
                <span className="text-[12px] font-semibold text-[#5f6368] uppercase tracking-wider block mb-1">
                  Entity Type
                </span>
                <span className="text-[16px] font-medium text-[#202124] block">
                  {entryType}
                </span>
              </div>
              <div>
                <span className="text-[12px] font-semibold text-[#5f6368] uppercase tracking-wider block mb-1">
                  State of Formation
                </span>
                <span className="text-[16px] font-medium text-[#202124] block">
                  {savedState}
                </span>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex items-center justify-between pt-4 border-t border-[#f1f3f4]">
            <button
              type="button"
              onClick={backbtn}
              className="px-6 py-2.5 rounded-[4px] border border-[#dadce0] text-[#1a73e8] font-medium hover:bg-[#f8f9fa] transition-colors flex items-center gap-2 cursor-pointer text-[14px]"
            >
              <i className="fa-solid fa-arrow-left text-xs"></i> Back
            </button>
            <button
              type="button"
              onClick={handleNextButtonClick}
              className="px-8 py-2.5 rounded-[4px] bg-[#1a73e8] hover:bg-[#1557b0] !text-white font-medium shadow-sm transition-all flex items-center gap-2 cursor-pointer text-[14px]"
            >
              Next <i className="fa-solid fa-arrow-right text-xs"></i>
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}